import { render, staticRenderFns } from "./scrollpage.vue?vue&type=template&id=4efc34ba&scoped=true"
import script from "./scrollpage.vue?vue&type=script&lang=js"
export * from "./scrollpage.vue?vue&type=script&lang=js"
import style0 from "./scrollpage.vue?vue&type=style&index=0&id=4efc34ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efc34ba",
  null
  
)

export default component.exports